<template>
<el-dialog
  title="单位列表"
  :visible.sync="dialogVisible"
  append-to-body
  @close="closeForm"
  width="1000px">
  <div class="container">
    <div style="width: 100%">
      <div class="fl-wrap mg-tp-sm">
        <div class="search-item">
          <span class="span">单位名称</span>
          <el-input clearable size="mini" style="width:160px;margin-right:15px;" v-model="searchForm.name"
            placeholder="请输入单位名称"></el-input>
        </div>
        <selectArea :area.sync="searchForm.area_id" :town.sync="searchForm.town" :village.sync="searchForm.village"></selectArea>
        <div class="search-item">
          <span class="span">固有风险</span>
          <el-select
            size="mini"
            style="width:140px"
            clearable
            v-model="searchForm.risk_level"
            placeholder="请选择固有风险等级">
            <el-option label="红色风险" value="1"></el-option>
            <el-option label="橙色风险" value="2"></el-option>
            <el-option label="黄色风险" value="3"></el-option>
            <el-option label="蓝色风险" value="4"></el-option>
            <el-option label="待评级" value="0"></el-option>
          </el-select>
        </div>
        <div class="search-item" v-permission="['has_dynamic_risk_level']">
          <span class="span">现实风险</span>
          <el-select
            size="mini"
            style="width:140px"
            clearable
            v-model="searchForm.dynamic_risk_level"
            placeholder="请选择现实风险等级">
            <el-option label="红色风险" value="1"></el-option>
            <el-option label="橙色风险" value="2"></el-option>
            <el-option label="黄色风险" value="3"></el-option>
            <el-option label="蓝色风险" value="4"></el-option>
            <el-option label="待评级" value="0"></el-option>
          </el-select>
        </div>
        <div class="search-item">
          <span class="span">行业监管部门</span>
          <el-cascader
            size="mini"
            ref="departmentTree"
            :show-all-levels="false"
            v-model="searchForm.parent_id"
            @change="change"
            :options="departmentData"
            :props="{ checkStrictly: true, label: 'name', value: 'id' }"
            clearable></el-cascader>
        </div>
        <div class="search-item">
          <span class="span">行业类型</span>
          <el-cascader
            style="width: 300px"
            @change="selectControlId"
            filterable
            size="mini"
            clearable
            :show-all-levels="false"
            :props="{ multiple: true }"
            collapse-tags
            v-model="searchForm.control_id"
            :options="industryOptions"></el-cascader>
        </div>
        <div class="search-item">
          <span class="span">单位信息采集情况</span>
          <el-select
            style="width:120px;margin-right:15px"
            size="mini"
            clearable
            v-model="searchForm.info_status"
            placeholder="请选择">
            <el-option label="已上报" :value="1"></el-option>
            <el-option label="未上报" :value="0"></el-option>
          </el-select>
        </div>
        <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="search">查询</el-button>
        <el-button
          v-permission="['has_high_level_query_permission']"
          class="mg-lf-sm"
          style="height: 28px"
          size="mini"
          type="primary"
          @click="heightSearch">高级查询</el-button>
        <div v-show="advancedSearch">
          <div class="fl-wrap mg-tp-sm">
            <el-checkbox class="mg-tp-sm" v-model="searchForm.company_level_two" true-label="2">存在重大隐患单位</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.company_level_one" true-label="1">存在一般隐患单位</el-checkbox>
            <!-- <el-checkbox class="mg-tp-sm" v-model="searchForm.is_supervision_check" true-label="1">最近监督检查单位</el-checkbox> -->
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_supervision_check" true-label="1">加入监督检查库单位</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_fire_safety_focus" true-label="1">属于消防重点单位</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_fire_danger" true-label="1">属于火灾高危单位</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_safety_insurance" true-label="1">购买安责险</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_has_limited_space_task" true-label="1">是否涉及有限空间作业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_overdue_safety_standard" true-label="1">安全标准化证书过期</el-checkbox>
            <!--应急 -->
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_metal_company" true-label="1">金属冶炼企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_deep_well_process" true-label="1">铝加工（深井铸造）企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_has_metal_dust" true-label="1">涉粉30人以上和铝镁等金属粉尘涉爆企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_has_ammonia" true-label="1">涉氨制冷企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_major_hazard_source" true-label="1">构成重大危险源</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_has_chlorine" true-label="1">涉氯企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.risk_level" true-label="1">重大安全风险等级（红色）企业</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_no_safety_standard" true-label="1">未创建安全标准化</el-checkbox>
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_three_ts_unfinished" true-label="1">三同时未完成</el-checkbox>
            <!-- <el-checkbox class="mg-tp-sm" v-model="searchForm.is_manager_no_train" true-label="1">主要管理或负责人没有培训</el-checkbox> -->
            <el-checkbox class="mg-tp-sm" v-model="searchForm.is_has_dust" true-label="1">涉及涉爆粉尘</el-checkbox>
          </div>
        </div>
      </div>
      <div class="mg-tp-sm">
        <el-table
          @select="select"
          @select-all="selectAll"
          ref="multipleTable"
          highlight-current-row
          :data="tableData"
          v-loading="loading"
          max-height="600"
          style="width: 100%;"
          :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
          :cell-style="{padding: '5px 0',color: '#303133'}"
          border
          stripe>
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            prop="name"
            label="单位名称"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="credit_code"
            label="统一信用代码"
            show-overflow-tooltip
            min-width="150">
          </el-table-column>
          <el-table-column
            prop="control"
            show-overflow-tooltip
            label="行业类型"
            min-width="180"></el-table-column>
          <el-table-column
            prop="risk_level"
            label="固有风险等级"
            show-overflow-tooltip
            min-width="100">
            <template slot-scope="scope">
              <div
                v-if="scope.row.risk_level == null"
                class="rectangle-border">
                <span>待评级</span>
              </div>
              <div v-else-if="scope.row.risk_level == 3">
                <el-tag class="rectangle-border-two" size="mini">黄色风险</el-tag>
              </div>
              <div v-else>
                <el-tag
                  size="mini"
                  :type="riskColorList1[scope.row.risk_level - 1]"
                  >{{ riskName[scope.row.risk_level - 1] }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-permission="['has_dynamic_risk_level']"
            prop="dynamic_risk_level"
            label="现实风险等级"
            show-overflow-tooltip
            min-width="100">
            <template slot-scope="scope">
              <div
                v-if="scope.row.dynamic_risk_level == null"
                class="rectangle-border">
                <span>待评级</span>
              </div>
              <div v-else-if="scope.row.dynamic_risk_level == 3">
                <el-tag class="rectangle-border-two" size="mini">黄色风险</el-tag>
              </div>
              <div v-else>
                <el-tag
                  size="mini"
                  :type="riskColorList1[scope.row.dynamic_risk_level - 1]"
                  >{{ riskName[scope.row.dynamic_risk_level - 1] }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="area.name"
            :formatter="(row) => row.area && row.area ? row.area: '--'"
            show-overflow-tooltip
            label="区域"
            width="200">
            <template slot-scope="{row}">
              {{row.area}}-{{row.town}}{{row.village ? '-' + row.village : ''}}
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <div style="float:right;padding:10px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 100, 500, 1000, 5000, 10000]"
                :page-size="10"
                layout="sizes, total, prev, pager, next, jumper"
                :total="totalCount">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
    <el-button size="mini" type="primary" @click="save">确 定</el-button>
  </span>
</el-dialog>
</template>

<script>
import selectArea from '@/components/selectArea/selectArea'
import {
  industryOptions as options
} from "@/Util/commonOptions";
import {industryOptions} from '@/Util/commonOptions'
import Search from '@/Util/Search'
import {api} from '@/api/api'
export default {
  components: {
    Search,
    selectArea
  },
  data () {
    return {
      industryOptions,
      searchForm:{
        area_id: null,
        town: null,
        village: null,
        name:null,
        risk_level:null,
        dynamic_risk_level:null,
        company_level_one:null,
        company_level_two:null,
        is_supervision_check:null,
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null,
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger:null,
        is_safety_insurance: null, // 购买安责险
        parent_id:'',
        info_status: null,
        control_id:''
      },
      riskColorList: ['bg-red', 'bg-orange', 'bg-yellow', 'bg-blue'],
      riskColorList1: ['danger', 'warning', 'blue'],
      riskName: ['红色风险', '橙色风险', '黄色风险', '蓝色风险'],
      dialogVisible: true,
      staff: null,
      loading: false,
      jobOptions: [],
      tableData: [],
      checkedData: null, // 选中的节点
      currentPage: 1,
      pageSize: 10,
      URL:'getCompanyList',
      totalCount: 0,
      parent_node_id: 0, // 父级ID
      parent_node_label: null, // 父级名称
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      callback: null,
      SelectionAll: {},
      SelectionTable: [],
      responsible_person: null,
      advancedSearch: false,
      search_control_id: '',
      build_industry:'',
    }
  },
  mounted () {
    this.getCompanyList()
    this.getDepartmentTreeList()
  },
  methods: {
    heightSearch () {
      this.advancedSearch = !this.advancedSearch
      this.searchForm = {
        area_id: null,
        town: null,
        village: null,
        name:null,
        risk_level:null,
        dynamic_risk_level:null,
        company_level_one:null,
        company_level_two:null,
        is_supervision_check:null,
        risk_level: null, // 重大安全风险等级（红色）企业
        is_metal_company: null, // 金属冶炼企业
        is_deep_well_process: null, // 铝加工（深井铸造）企业
        is_has_metal_dust: null, // 涉粉30人以上和铝镁等金属粉尘涉爆企业
        is_has_ammonia: null, // 涉氨制冷企业
        is_has_chlorine: null, // 涉氯企业
        is_has_limited_space_task: null, // 是否涉及有限空间作业
        is_major_hazard_source: null, // 是否构成重大危险源
        development_area_name: null, // 企业园区
        is_no_safety_standard: null, // 未创建安全标准化
        is_overdue_safety_standard: null, // 安全标准化过期
        is_three_ts_unfinished: null, //  三同时未完成
        is_manager_no_train: null, // 主要管理或负责人没有培训
        is_has_dust: null,
        is_fire_safety_focus: null, // 属于消防重点单位
        is_fire_danger:null,
        is_safety_insurance: null, // 购买安责险
        parent_id:'',
        info_status: null,
        control_id:''
      }
    },
    getareaList(row) {
      if (row.id) {
        this.searchForm.parent_id = row.id
        this.getList()
      }
    },
    change (val) {
      let data = this.$refs.departmentTree.getCheckedNodes(true)
      if(data && data.length>0){
        // this.searchForm.department_area_id = data[0].data.area_id
        // this.searchForm.department_type_id = data[0].data.department_type_id
        // this.searchForm.tree_id = data[0].data.id
        this.searchForm.parent_id = data[0].data.id
      }
    },
    selectControlId (val) {
      this.search_control_id = val.map(v => {
        return v[1]
      })
      this.build_industry = val.map(v => {
        return v[0]
      })
    },
    getDepartmentTreeList () {
      this.$http.post(api.getDepartmentTreeList, {is_clear_safety_department: 1}).then(res => {
        if (res.data.code == 0) {
          this.departmentData = res.data.data
          this.departmentData.forEach(v => {
            v.name = `${v.name}`
          })
        }
      })
    },
    search() {
      this.currentPage = 1
      this.getCompanyList()
    },
    deleteStaff (row, index) {
      this.select({}, row)
      this.$nextTick(() => {
        this.getCompanyList()
      })
    },
    closeForm () {
      this.staff = null
      this.checkedData = null
      // this.$refs['table'].setCurrentRow()
      this.$el.parentNode.removeChild(this.$el);
    },
    save () {
      if (this.SelectionTable.length == 0) {
        return this.$message({
          type: 'warning',
          message: '请选择单位'
        })
      }
      if (this.callback && typeof(this.callback) === 'function') {
        this.callback(this.SelectionTable)
      }
      // this.$emit('getStaff', staff)
      this.dialogVisible = false
    },
    currentChange (currentRow) {
      if (currentRow) {
        this.staff = currentRow
      }
    },
    // // 获取员工账号列表
    getCompanyList () {
      let params = {
        page_index: this.currentPage,
        page_size: this.pageSize
      }
      for (let key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          params[key] = this.searchForm[key]
        }
      }
      if (params.control_id) {
        params.control_id = params.control_id.map(v => {
          return v[1]
        })
      }
      this.loading = true
      this.$http.post(
        api[this.URL],
        params
      ).then(response => {
        this.tableData = response.data.data
        this.$nextTick(() => {
          this.checkSelect()
        })
        this.totalCount = response.data.page_info.total_num
        this.loading = false
      }).catch((error) => {
        console.log(error)
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getCompanyList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getCompanyList()
    },
    select (selection, row) {
      for (let key in this.SelectionAll) {
        if (key == row.id) {
          delete this.SelectionAll[key]
          this.SelectionTable = Object.values(this.SelectionAll)
          return
        }
      }
      this.SelectionAll[row.id] = row
      this.SelectionTable = Object.values(this.SelectionAll)
    },
    selectAll (select) {
      for (let row of this.tableData) {
        if (select.length === 0) {
          delete this.SelectionAll[row.id]
        } else {
          this.SelectionAll[row.id] = row
        }
      }
      this.SelectionTable = Object.values(this.SelectionAll)
    },
    // 每次刷新时检查是否有选项，并设置已选中
    checkSelect () {
      for (let row of this.tableData) {
        if (this.SelectionAll.hasOwnProperty(row.id)) {
          this.$refs.multipleTable.toggleRowSelection(row,true)
        }
      }
    }
  }
}
</script>

<style scoped>
.rectangle {
  width: 80px;
  height: 20px;
  padding: 0 10px;
  text-align: center;
}
.rectangle-border {
  border: 1px solid #666;
  width: 80px;
  height: 20px;
  padding: 0 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: red;
  font-size: 12px;
  border-radius: 5px;
}

  .rectangle-border-two {
    border: 1px solid #fadb14;
    width: 60px;
    height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fffb8f;
    color: #ad8b00;
    font-size: 12px;
    border-radius: 5px;
    opacity: 0.8;
  }
  .container {
    display: flex;
    flex-wrap: nowrap;
    padding-top: 20px;
  }
  .span {
    font-size: 14px;
    line-height: 32px;
    margin:0 5px 10px 0;
  }
  .item {
    width: 160px;
    margin:0 15px 10px 0;
  }
  .el-input {
  /* width: 160px !important; */
  /* margin:0 5px 10px 0 ; */
  }
  .left {
    margin-left: 15px;
  }
  .title {
    font-size: 18px;
    font-weight: 900;
  }
  .fl-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .mg-tp-sm {
    margin-top: 8px;
  }
  .span {
    margin: 8px;
  }
  .search-item {
    margin: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/selectCompany/selectCompanyDialog.vue